'use client';

import { useEffect, useState } from "react";
import CatSections from "@/components/collections/CatSections";
export default function CategorySectionsLoader({
  catSlug
}) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchSections() {
      if (!catSlug) return;
      try {
        const res = await fetch(`/api/catsections/${catSlug}`);
        const data = await res.json();
        setSections(data?.sections || []);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchSections();
  }, [catSlug]);
  if (loading) {
    return null;
  }
  if (!sections?.length) {
    return null;
  }
  return <CatSections sections={sections} />;
}